import React from 'react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-paper dark:bg-noir py-16 sm:py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-cream dark:bg-card rounded-2xl p-6 md:p-10 brutal-border brutal-shadow-lg">
          <a
            href="/"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sun text-ink font-display font-bold text-sm brutal-border-thin brutal-hover mb-8"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Home
          </a>

          <div>
            <h1 className="font-display text-3xl md:text-4xl font-extrabold text-ink dark:text-cream mb-2">Terms of Service</h1>

            <p className="text-ink/60 dark:text-cream/60 mb-8 text-sm font-bold">
              Last Updated: September 7, 2025
            </p>

            <p className="text-ink/70 dark:text-cream/70 mb-6 leading-relaxed">
              Welcome to Tushar Anand's Portfolio. These terms and conditions outline the rules and regulations for the use of Tushar Anand's website, located at tusharanand.in.
            </p>

            <p className="text-ink/70 dark:text-cream/70 mb-6 leading-relaxed">
              By accessing this website we assume you accept these terms and conditions. Do not continue to use Tushar Anand's Portfolio if you do not agree to take all of the terms and conditions stated on this page.
            </p>
            
            <h2 className="font-display text-2xl font-extrabold text-ink dark:text-cream mt-10 mb-4 pt-6 border-t-2 border-ink/15 dark:border-cream/15">Intellectual Property</h2>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              Unless otherwise stated, Tushar Anand and/or its licensors own the intellectual property rights for all material on this website. All intellectual property rights are reserved. You may access this from this website for your own personal use subjected to restrictions set in these terms and conditions.
            </p>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              You must not:
            </p>
            
            <ul className="list-disc pl-6 marker:text-mint text-ink/70 dark:text-cream/70 mb-4 space-y-2">
              <li>Republish material from this website</li>
              <li>Sell, rent or sub-license material from the website</li>
              <li>Reproduce, duplicate or copy material from the website</li>
              <li>Redistribute content from this website</li>
            </ul>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              This Agreement shall begin on the date hereof.
            </p>
            
            <h2 className="font-display text-2xl font-extrabold text-ink dark:text-cream mt-10 mb-4 pt-6 border-t-2 border-ink/15 dark:border-cream/15">User Comments</h2>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. Tushar Anand does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of Tushar Anand, its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions.
            </p>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              To the extent permitted by applicable laws, Tushar Anand shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.
            </p>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              Tushar Anand reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms.
            </p>
            
            <h3 className="font-display text-xl font-extrabold text-ink dark:text-cream mt-6 mb-3">You warrant and represent that:</h3>
            
            <ul className="list-disc pl-6 marker:text-mint text-ink/70 dark:text-cream/70 mb-4 space-y-2">
              <li>You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;</li>
              <li>The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;</li>
              <li>The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy</li>
              <li>The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.</li>
            </ul>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              You hereby grant Tushar Anand a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.
            </p>
            
            <h2 className="font-display text-2xl font-extrabold text-ink dark:text-cream mt-10 mb-4 pt-6 border-t-2 border-ink/15 dark:border-cream/15">Hyperlinking to our Content</h2>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              The following organizations may link to our website without prior written approval:
            </p>
            
            <ul className="list-disc pl-6 marker:text-mint text-ink/70 dark:text-cream/70 mb-4 space-y-2">
              <li>Government agencies;</li>
              <li>Search engines;</li>
              <li>News organizations;</li>
              <li>Online directory distributors may link to our website in the same manner as they hyperlink to the Websites of other listed businesses; and</li>
              <li>System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site.</li>
            </ul>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party's site.
            </p>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              We may consider and approve other link requests from the following types of organizations:
            </p>
            
            <ul className="list-disc pl-6 marker:text-mint text-ink/70 dark:text-cream/70 mb-4 space-y-2">
              <li>commonly-known consumer and/or business information sources;</li>
              <li>dot.com community sites;</li>
              <li>associations or other groups representing charities;</li>
              <li>online directory distributors;</li>
              <li>internet portals;</li>
              <li>accounting, law and consulting firms; and</li>
              <li>educational institutions and trade associations.</li>
            </ul>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the benefit to us from the visibility of the hyperlink compensates the absence of Tushar Anand; and (d) the link is in the context of general resource information.
            </p>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party's site.
            </p>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to Tushar Anand. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.
            </p>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              Approved organizations may hyperlink to our Website as follows:
            </p>
            
            <ul className="list-disc pl-6 marker:text-mint text-ink/70 dark:text-cream/70 mb-4 space-y-2">
              <li>By use of our corporate name; or</li>
              <li>By use of the uniform resource locator being linked to; or</li>
              <li>By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party's site.</li>
            </ul>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              No use of Tushar Anand's logo or other artwork will be allowed for linking absent a trademark license agreement.
            </p>
            
            <h2 className="font-display text-2xl font-extrabold text-ink dark:text-cream mt-10 mb-4 pt-6 border-t-2 border-ink/15 dark:border-cream/15">iFrames</h2>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.
            </p>
            
            <h2 className="font-display text-2xl font-extrabold text-ink dark:text-cream mt-10 mb-4 pt-6 border-t-2 border-ink/15 dark:border-cream/15">Content Liability</h2>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.
            </p>
            
            <h2 className="font-display text-2xl font-extrabold text-ink dark:text-cream mt-10 mb-4 pt-6 border-t-2 border-ink/15 dark:border-cream/15">Reservation of Rights</h2>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and it's linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.
            </p>
            
            <h2 className="font-display text-2xl font-extrabold text-ink dark:text-cream mt-10 mb-4 pt-6 border-t-2 border-ink/15 dark:border-cream/15">Removal of links from our website</h2>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.
            </p>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.
            </p>
            
            <h2 className="font-display text-2xl font-extrabold text-ink dark:text-cream mt-10 mb-4 pt-6 border-t-2 border-ink/15 dark:border-cream/15">Disclaimer</h2>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:
            </p>
            
            <ul className="list-disc pl-6 marker:text-mint text-ink/70 dark:text-cream/70 mb-4 space-y-2">
              <li>limit or exclude our or your liability for death or personal injury;</li>
              <li>limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
              <li>limit any of our or your liabilities in any way that is not permitted under applicable law; or</li>
              <li>exclude any of our or your liabilities that may not be excluded under applicable law.</li>
            </ul>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.
            </p>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.
            </p>
            
            <h2 className="font-display text-2xl font-extrabold text-ink dark:text-cream mt-10 mb-4 pt-6 border-t-2 border-ink/15 dark:border-cream/15">Contact Information</h2>
            
            <p className="text-ink/70 dark:text-cream/70 mb-4 leading-relaxed">
              If you have any questions about these Terms of Service, please contact us:
            </p>
            
            <ul className="list-disc pl-6 marker:text-mint text-ink/70 dark:text-cream/70 mb-4 space-y-2">
              <li>By email: tushar.anand.bpmce@gmail.com</li>
              <li>By phone: +91-9060177959</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;